<template>
  <div class="pd-dashboard-ingreso">
    
    <!-- FILTRO LOCAL DE MATERIAL -->
    <div class="pd-receipt-header">
      <div>
        <h2><i class="fa-solid fa-filter" style="color: #058c99;"></i> Filtrado de {{ textMaterials }}</h2>
        <p>Filtra los indicadores y gráficos de {{ textReceipt.toLowerCase() }} por un {{ textMaterial.toLowerCase() }} específico</p>
      </div>
      <div style="width: 320px;">
        <DashboardSelect 
          v-model="localSku" 
          :options="skuList" 
          :placeholder="'Todos los ' + textMaterials.toLowerCase()" 
        />
      </div>
    </div>

    <!-- TARJETAS SUPERIORES (KPIs) -->
    <div class="pds__kpis">
      <div class="pds__kpi">
        <div class="pds__kpi-top">
          <span class="pds__kpi-label">Órdenes de Compra</span>
          <i class="fa-solid fa-boxes-packing" style="color: #058c99;"></i>
        </div>
        <h3 class="pds__kpi-value">{{ totalOrders }}</h3>
        <p class="pds__kpi-sub">Órdenes</p>
      </div>

      <div class="pds__kpi">
        <div class="pds__kpi-top">
          <span class="pds__kpi-label">Cantidad Comprada</span>
          <i class="fa-solid fa-box-open" style="color: #058c99;"></i>
        </div>
        <h3 class="pds__kpi-value">{{ formatQuantity(totalBought) }}</h3>
        <p class="pds__kpi-sub">{{ textUnits }}</p>
      </div>

      <div class="pds__kpi">
        <div class="pds__kpi-top">
          <span class="pds__kpi-label">Cantidad {{ textReceived }}</span>
          <i class="fa-solid fa-truck-ramp-box" style="color: #1ed760;"></i>
        </div>
        <h3 class="pds__kpi-value">{{ formatQuantity(totalReceived) }}</h3>
        <p class="pds__kpi-sub">{{ textUnits }}</p>
      </div>

      <div class="pds__kpi">
        <div class="pds__kpi-top">
          <span class="pds__kpi-label" style="color: #ff4b4b;">Pendiente por {{ textToReceive }}</span>
          <i class="fa-solid fa-clipboard-list" style="color: #ff4b4b;"></i>
        </div>
        <h3 class="pds__kpi-value" style="color: #ff4b4b;">{{ formatQuantity(pending) }}</h3>
        <p class="pds__kpi-sub">{{ textUnits }}</p>
      </div>

      <div class="pds__kpi">
        <div class="pds__kpi-top">
          <span class="pds__kpi-label">% Cumplimiento</span>
          <i class="fa-solid fa-bolt" style="color: #1ed760;"></i>
        </div>
        <h3 class="pds__kpi-value" style="color: #1ed760;">{{ fulfillmentPercent }} %</h3>
        <p class="pds__kpi-sub">Cumplimiento</p>
      </div>
    </div>

    <!-- GRÁFICOS MEDIOS -->
    <div class="pds__charts-row2" style="margin-top: 24px;">
      
      <div class="pds__chart-card">
        <div class="pds__card-head"><h3>% Cumplimiento por Proveedor</h3><p>Top 5 proveedores con mejor atención</p></div>
        <div class="pds__chart-wrap">
          <canvas id="chart-supplier-fulfillment"></canvas>
        </div>
      </div>

      <div class="pds__chart-card">
        <div class="pds__card-head"><h3>Estado de las Órdenes de Compra</h3><p>Distribución de atención</p></div>
        <div class="pds__chart-wrap" style="display: flex; flex-direction: column; gap: 12px;">
          <div style="display: flex; justify-content: space-around; width: 100%;">
            <div style="display: flex; flex-direction: column; align-items: center; text-align: center;">
              <div style="display: flex; align-items: center; gap: 4px;">
                <span style="width: 8px; height: 8px; border-radius: 50%; background: #1ed760; flex-shrink: 0;"></span>
                <span class="pds__legend-sub" style="font-size: 9px; text-transform: uppercase; font-weight: 600;">Completas</span>
              </div>
              <span class="pds__legend-label" style="font-size: 11px; font-weight: 700; margin-top: 2px;">{{ statusStats.pComp }}% ({{ statusStats.comp }})</span>
            </div>
            <div style="display: flex; flex-direction: column; align-items: center; text-align: center;">
              <div style="display: flex; align-items: center; gap: 4px;">
                <span style="width: 8px; height: 8px; border-radius: 50%; background: #fbc02d; flex-shrink: 0;"></span>
                <span class="pds__legend-sub" style="font-size: 9px; text-transform: uppercase; font-weight: 600;">Parciales</span>
              </div>
              <span class="pds__legend-label" style="font-size: 11px; font-weight: 700; margin-top: 2px;">{{ statusStats.pParc }}% ({{ statusStats.parc }})</span>
            </div>
            <div style="display: flex; flex-direction: column; align-items: center; text-align: center;">
              <div style="display: flex; align-items: center; gap: 4px;">
                <span style="width: 8px; height: 8px; border-radius: 50%; background: #ff4b4b; flex-shrink: 0;"></span>
                <span class="pds__legend-sub" style="font-size: 9px; text-transform: uppercase; font-weight: 600;">{{ textNoReceipt }}</span>
              </div>
              <span class="pds__legend-label" style="font-size: 11px; font-weight: 700; margin-top: 2px;">{{ statusStats.pSin }}% ({{ statusStats.sin }})</span>
            </div>
          </div>
          <div style="flex: 1; min-height: 0; position: relative;">
            <canvas id="chart-order-status-donut"></canvas>
          </div>
        </div>
      </div>

      <div class="pds__chart-card">
        <div class="pds__card-head"><h3>{{ textReceipt }} de {{ textMaterials }} en el Tiempo</h3><p>Evolución de compras vs {{ textReceipts.toLowerCase() }}</p></div>
        <div class="pds__chart-wrap">
          <canvas id="chart-time-materials"></canvas>
        </div>
      </div>

      <div class="pds__chart-card">
        <div class="pds__card-head"><h3>Valorizado de {{ textReceipts }} ($)</h3><p>Evolución monetaria de compras vs {{ textReceipts.toLowerCase() }}</p></div>
        <div class="pds__chart-wrap">
          <canvas id="chart-time-valorizado"></canvas>
        </div>
      </div>
    </div>

    <!-- TABLA DE DETALLE -->
    <DashboardTable
      title="Detalle de Órdenes de Compra"
      :subtitle="'Seguimiento individual por ' + textMaterial.toLowerCase() + ' y proveedor'"
      :items="tableData"
      :searchKeys="['OrdDocumentNumber', 'DocNumSap', 'SupName', 'ItemDescription', 'ItemCode']"
      :filterableColumns="[{ key: 'OrdStatusName', label: 'Todos los estados' }]"
      :itemsPerPage="perPage"
      :pagination="true"
      :page="page"
      :search="tableSearch"
      @update:search="tableSearch = $event"
      @update:page="page = $event"
      style="margin-top: 24px;"
      :headers="tableHeaders"
    >
      <template #row="{ item }">
        <tr :key="item.OrdID + '-' + item.OddID">
          <td style="white-space: nowrap;"><span class="pds__badge-oc">{{ item.OrdDocumentNumber }}</span></td>
          <td style="white-space: nowrap;"><span class="pds__badge-oc">{{ item.DocNumSap || '-' }}</span></td>
          <td style="white-space: nowrap;">{{ item.OrdDate }}</td>
          <td style="white-space: nowrap;">{{ item.SupName }}</td>
          <td style="min-width: 150px;">{{ item.ItemDescription }}</td>
          <td style="white-space: nowrap;">{{ item.UnitMeasurement || 'UND' }}</td>
          <td style="text-align: right; white-space: nowrap;">{{ formatInt(item.Quantity) }}</td>
          <td style="text-align: right; white-space: nowrap;">{{ formatInt(item.ReceivedQuantity) }}</td>
          <td style="text-align: right; white-space: nowrap;">{{ formatInt(getPending(item)) }}</td>
          <td style="min-width: 120px;">
            <div style="display: flex; align-items: center; gap: 8px;">
               <div style="flex: 1; background: var(--pd-border, #E2E8F0); height: 8px; border-radius: 4px; overflow: hidden;">
                 <div :style="{ width: getAdvance(item) + '%', background: '#058c99', height: '100%' }"></div>
               </div>
               <span style="font-size: 11px;">{{ getAdvance(item) }}%</span>
            </div>
          </td>
          <td style="white-space: nowrap;">{{ item.PromisedDate || 'N/A' }}</td>

          <td style="white-space: nowrap; text-align: center;">
            <span class="pds__estado" :class="'pds__estado--' + getStatusClass(item)">
              {{ getStatusLabel(item) }}
            </span>
          </td>
        </tr>
      </template>
    </DashboardTable>
  </div>
</template>

<script>
import DashboardSelect from './DashboardSelect.vue';
import DashboardTable from './DashboardTable.vue';

export default {
  name: 'DashboardReceipt',
  components: { DashboardSelect, DashboardTable },
  props: {
    dataset: { type: Array, required: true },
    orderType: { type: [String, Number], default: null },
    isDark: { type: Boolean, default: false }
  },
  data() {
    return {
      localSku: null,
      chartSupplier: null,
      chartStatus: null,
      chartTime: null,
      chartTimeValorizado: null,
      tableSearch: '',
      page: 1,
      perPage: 10
    };
  },
  computed: {
    isService() { return String(this.orderType) === '3'; },
    textMaterial() { return this.isService ? 'Servicio' : 'Material'; },
    textMaterials() { return this.isService ? 'Servicios' : 'Materiales'; },
    textReceipt() { return this.isService ? 'Ejecución' : 'Ingreso'; },
    textReceipts() { return this.isService ? 'Ejecuciones' : 'Ingresos'; },
    textReceived() { return this.isService ? 'Ejecutada' : 'Ingresada'; },
    textReceivedMasc() { return this.isService ? 'Ejecutado' : 'Ingresado'; },
    textToReceive() { return this.isService ? 'Ejecutar' : 'Ingresar'; },
    textNoReceipt() { return this.isService ? 'Sin Ejecución' : 'Sin Ingreso'; },
    textUnits() { return this.isService ? 'Servicios' : 'Unidades'; },
    
    filteredDataset() {
      if (!this.localSku || this.localSku === 'ALL') return this.dataset;
      return this.dataset.filter(r => (this.isService ? r.ItemDescription : r.ItemCode) === this.localSku);
    },
    skuList() {
      const map = new Map();
      this.dataset.forEach(r => {
        const key = this.isService ? (r.ItemDescription || 'Sin Descripción') : r.ItemCode;
        const label = this.isService ? (r.ItemDescription || 'Sin Descripción') : `${r.ItemCode} - ${r.ItemDescription || ''}`;
        
        if (key && !map.has(key)) {
          map.set(key, { value: key, label: label });
        }
      });
      return Array.from(map.values()).sort((a,b) => a.label.localeCompare(b.label));
    },
    totalOrders() {
      const unique = new Set(this.filteredDataset.map(x => x.OrdDocumentNumber));
      return unique.size;
    },
    totalBought() {
      return this.filteredDataset.reduce((sum, item) => sum + (item.Quantity || 0), 0);
    },
    totalReceived() {
      return this.filteredDataset.reduce((sum, item) => sum + (item.ReceivedQuantity || 0), 0);
    },
    pending() {
      return this.filteredDataset.reduce((sum, item) => {
         const p = (item.Quantity || 0) - (item.ReceivedQuantity || 0);
         return sum + (p > 0 ? p : 0);
      }, 0);
    },
    fulfillmentPercent() {
      if (this.totalBought === 0) return 0.0;
      return ((this.totalReceived / this.totalBought) * 100).toFixed(1);
    },
    tableHeaders() {
      return [
        { label: 'N° OC SUN EXPERT', key: 'OrdDocumentNumber', sortable: true },
        { label: 'N° PEDIDO SAP', key: 'DocNumSap', sortable: true },
        { label: 'Fecha OC', key: 'OrdDate', sortable: true },
        { label: 'Proveedor', key: 'SupName', sortable: true },
        { label: this.textMaterial, key: 'ItemDescription', sortable: true },
        { label: 'Unidad', key: 'UnitMeasurement', sortable: true },
        { label: 'Cantidad OC', key: 'Quantity', sortable: true, align: 'right' },
        { label: 'Cantidad ' + this.textReceived, key: 'ReceivedQuantity', sortable: true, align: 'right' },
        { label: 'Saldo Pendiente', key: 'PendingBalance', sortable: false, align: 'right' },
        { label: '% Avance', key: 'AdvancementPercentage', sortable: false },
        { label: 'Fecha Compromiso', key: 'PromisedDate', sortable: true },
        { label: 'Estado', key: 'OrdStatusName', sortable: true, align: 'center' }
      ];
    },
    tableData() {
      let data = this.filteredDataset.slice();
      data.sort((a,b) => {
         return new Date((b.OrdDate||'').split('/').reverse().join('-')) - new Date((a.OrdDate||'').split('/').reverse().join('-'));
      });
      return data;
    },
    statusStats() {
       let comp = 0, parc = 0, sin = 0;
       const uniqueOrders = {};
       this.filteredDataset.forEach(d => {
           if (!uniqueOrders[d.OrdDocumentNumber]) uniqueOrders[d.OrdDocumentNumber] = { q: 0, r: 0 };
           uniqueOrders[d.OrdDocumentNumber].q += (d.Quantity || 0);
           uniqueOrders[d.OrdDocumentNumber].r += (d.ReceivedQuantity || 0);
       });
       Object.values(uniqueOrders).forEach(o => {
           if (o.r >= o.q && o.q > 0) comp++;
           else if (o.r > 0 && o.r < o.q) parc++;
           else sin++;
       });
       const total = comp + parc + sin;
       return {
         comp, parc, sin,
         pComp: total === 0 ? '0.00' : ((comp / total) * 100).toFixed(2),
         pParc: total === 0 ? '0.00' : ((parc / total) * 100).toFixed(2),
         pSin: total === 0 ? '0.00' : ((sin / total) * 100).toFixed(2)
       };
    },
  },
  watch: {
    filteredDataset: {
      immediate: true,
      handler() {
        this.page = 1;
        this.$nextTick(() => {
          this.renderCharts();
        });
      }
    },
    isDark() {
      this.$nextTick(() => { this.renderCharts(); });
    }
  },
  methods: {
    formatQuantity(val) {
      if (!val) return '0';
      if (val >= 1000000) return (val / 1000000).toFixed(2) + ' M';
      if (val >= 1000) return (val / 1000).toFixed(1) + ' K';
      return val.toLocaleString('en-US', { maximumFractionDigits: 0 });
    },
    formatInt(val) {
      if (!val) return '0';
      return val.toLocaleString('en-US', { maximumFractionDigits: 0 });
    },
    getPending(item) {
       const q = item.Quantity || 0;
       const r = item.ReceivedQuantity || 0;
       return q - r > 0 ? q - r : 0;
    },
    getAdvance(item) {
       const q = item.Quantity || 0;
       const r = item.ReceivedQuantity || 0;
       if (q === 0) return 0;
       let perc = (r / q) * 100;
       if (perc > 100) perc = 100;
       return perc.toFixed(1);
    },
    getDelayDays(item) {
       if (!item.PromisedDate) return 0;
       
       // PromisedDate is "DD/MM/YYYY" or Similar depending on backend. We assume "DD/MM/YYYY" due to Convert(varchar, 103)
       const parts = item.PromisedDate.split('/');
       if(parts.length < 3) return 0;
       const promisedDateObj = new Date(parts[2], parts[1]-1, parts[0]);
       
       let compareDateObj = new Date(); // default to today
       if (item.FirstReceiptDate) {
           const rParts = item.FirstReceiptDate.split('/');
           if(rParts.length === 3) {
               compareDateObj = new Date(rParts[2], rParts[1]-1, rParts[0]);
           }
       }
       
       const diffTime = Math.abs(compareDateObj - promisedDateObj);
       let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
       
       // If compareDate > promisedDate => delayed (>0)
       // If compareDate <= promisedDate => advance (<=0)
       if (compareDateObj <= promisedDateObj) {
           return -diffDays;
       }
       return diffDays;
    },
    getStatusLabel(item) {
       const p = this.getPending(item);
       const q = item.Quantity || 0;
       if (p === 0 && q > 0) return 'Completada';
       if (p > 0 && p < q) return 'Parcial';
       return 'Sin Ingreso';
    },
    getStatusClass(item) {
       const s = this.getStatusLabel(item);
       if(s === 'Completada') return 'closed';
       if(s === 'Parcial') return 'open';
       return 'canceled';
    },
    renderCharts() {
      if (!window.Chart) return;
      this.renderSupplierChart();
      this.renderStatusChart();
      this.renderTimeChart();
      this.renderTimeValorizadoChart();
    },
    // Grafico 1: Cumplimiento por Proveedor
    renderSupplierChart() {
       const ctx = document.getElementById('chart-supplier-fulfillment');
       if (!ctx) return;
       if (this.chartSupplier) this.chartSupplier.destroy();
       
       const tc = this.isDark ? '#F8FAFC' : '#64748B';
       
       const suppliers = {};
       this.filteredDataset.forEach(d => {
           if (!suppliers[d.SupName]) suppliers[d.SupName] = { q: 0, r: 0 };
           suppliers[d.SupName].q += (d.Quantity || 0);
           suppliers[d.SupName].r += (d.ReceivedQuantity || 0);
       });
       
       let suppArray = Object.keys(suppliers).map(k => {
           let perc = suppliers[k].q === 0 ? 0 : (suppliers[k].r / suppliers[k].q)*100;
           return { name: k, perc: perc > 100 ? 100 : perc };
       });
       
       suppArray.sort((a,b) => b.perc - a.perc);
       suppArray = suppArray.slice(0, 5); // top 5
       
       const drawValuesPlugin = {
          id: 'drawValues',
          afterDatasetsDraw(chart) {
              const { ctx } = chart;
              chart.data.datasets.forEach((dataset, i) => {
                  const meta = chart.getDatasetMeta(i);
                  meta.data.forEach((bar, index) => {
                      const data = dataset.data[index];
                      if (data > 0) {
                          ctx.fillStyle = window.getComputedStyle(chart.canvas).getPropertyValue('--pd-text-muted') || tc;
                          ctx.font = '600 11px Inter, sans-serif';
                          ctx.textAlign = 'left';
                          ctx.textBaseline = 'middle';
                          ctx.fillText(data.toFixed(1) + '%', bar.x + 6, bar.y);
                      }
                  });
              });
          }
       };

       this.chartSupplier = new window.Chart(ctx, {
          type: 'bar',
          data: {
             labels: suppArray.map(x => x.name),
             datasets: [{
                 label: '% Cumplimiento',
                 data: suppArray.map(x => x.perc),
                 backgroundColor: '#058c99',
                 borderRadius: 4
             }]
          },
          options: {
              indexAxis: 'y',
              responsive: true,
              maintainAspectRatio: false,
              layout: { padding: { right: 45 } },
              plugins: { legend: { display: false } },
              scales: { 
                 x: { max: 100, display: false },
                 y: { 
                   ticks: { 
                     color: tc,
                     callback: function(val) {
                       let label = this.getLabelForValue(val) || '';
                       if (label.length <= 20) return label;
                       const words = label.split(' ');
                       const lines = [];
                       let current = '';
                       for (let w of words) {
                         if ((current + w).length > 20) {
                           if (current) lines.push(current.trim());
                           current = w + ' ';
                         } else {
                           current += w + ' ';
                         }
                       }
                       if (current) lines.push(current.trim());
                       return lines;
                     }
                   }, 
                   grid: { display: false } 
                 }
              }
          },
          plugins: [drawValuesPlugin]
       });
    },
    // Grafico 2: Estado OC
    renderStatusChart() {
       const ctx = document.getElementById('chart-order-status-donut');
       if (!ctx) return;
       if (this.chartStatus) this.chartStatus.destroy();
       
       const { comp, parc, sin } = this.statusStats;
       
       this.chartStatus = new window.Chart(ctx, {
          type: 'doughnut',
          data: {
             labels: ['Completadas', 'Parciales', 'Sin Ingreso'],
             datasets: [{
                 data: [comp, parc, sin],
                 backgroundColor: ['#1ed760', '#fbc02d', '#ff4b4b'],
                 borderWidth: 0,
                 hoverOffset: 4
             }]
          },
          options: {
              responsive: true,
              maintainAspectRatio: false,
              cutout: '65%',
              plugins: { legend: { display: false } }
          }
       });
    },
    // Grafico 3: Ingreso en el Tiempo
    renderTimeChart() {
       const ctx = document.getElementById('chart-time-materials');
       if (!ctx) return;
       if (this.chartTime) this.chartTime.destroy();
       
       const tc = this.isDark ? '#F8FAFC' : '#64748B';
       const gc = this.isDark ? '#334155' : 'rgba(0,0,0,0.1)';
       const boughtColor = this.isDark ? '#F8FAFC' : '#424242';
       
       const monthly = {};
       this.filteredDataset.forEach(d => {
           const parts = d.OrdDate.split('/'); // DD/MM/YYYY
           if(parts.length===3) {
               const key = `${parts[1]}/${parts[2]}`;
               if (!monthly[key]) monthly[key] = { q: 0, r: 0 };
               monthly[key].q += (d.Quantity || 0);
               monthly[key].r += (d.ReceivedQuantity || 0);
           }
       });
       
       const sortedKeys = Object.keys(monthly).sort((a,b) => {
           const [ma, ya] = a.split('/');
           const [mb, yb] = b.split('/');
           return new Date(ya, ma-1) - new Date(yb, mb-1);
       });
       
       const dataQ = sortedKeys.map(k => monthly[k].q);
       const dataR = sortedKeys.map(k => monthly[k].r);
       
       this.chartTime = new window.Chart(ctx, {
          type: 'line',
          data: {
             labels: sortedKeys,
             datasets: [
                 {
                     label: 'Cantidad Comprada',
                     data: dataQ,
                     borderColor: boughtColor,
                     backgroundColor: 'transparent',
                     borderWidth: 2,
                     pointRadius: 3
                 },
                 {
                     label: 'Cantidad ' + this.textReceived,
                     data: dataR,
                     borderColor: '#058c99',
                     backgroundColor: 'rgba(5, 140, 153, 0.2)',
                     borderWidth: 2,
                     pointRadius: 3,
                     fill: true
                 }
             ]
          },
          options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: { legend: { position: 'top', labels: { color: tc } } },
              scales: { 
                x: { ticks: { color: tc }, grid: { color: gc } },
                y: { beginAtZero: true, ticks: { color: tc }, grid: { color: gc } } 
              },
              interaction: { mode: 'index', intersect: false }
          }
       });
    },
    // Grafico 4: Valorizado en el Tiempo
    renderTimeValorizadoChart() {
       const ctx = document.getElementById('chart-time-valorizado');
       if (!ctx) return;
       if (this.chartTimeValorizado) this.chartTimeValorizado.destroy();
       
       const tc = this.isDark ? '#F8FAFC' : '#64748B';
       const gc = this.isDark ? '#334155' : 'rgba(0,0,0,0.1)';
       
       const monthly = {};
       this.filteredDataset.forEach(d => {
           const parts = d.OrdDate.split('/'); // DD/MM/YYYY
           if(parts.length===3) {
               const key = `${parts[1]}/${parts[2]}`;
               if (!monthly[key]) monthly[key] = { valC: 0, valR: 0 };
               
               // TotalAmount is USD value of Purchase Order line
               monthly[key].valC += (d.TotalAmount || 0);
               
               // Received USD is quantity received * unit price USD
               monthly[key].valR += ((d.ReceivedQuantity || 0) * (d.UnitPrice || 0));
           }
       });
       
       const sortedKeys = Object.keys(monthly).sort((a,b) => {
           const [ma, ya] = a.split('/');
           const [mb, yb] = b.split('/');
           return new Date(ya, ma-1) - new Date(yb, mb-1);
       });
       
       const dataValC = sortedKeys.map(k => monthly[k].valC);
       const dataValR = sortedKeys.map(k => monthly[k].valR);
       
       this.chartTimeValorizado = new window.Chart(ctx, {
          type: 'line',
          data: {
             labels: sortedKeys,
             datasets: [
                 {
                     label: 'Monto Comprado ($)',
                     data: dataValC,
                     borderColor: '#fbc02d',
                     backgroundColor: 'transparent',
                     borderWidth: 2,
                     pointRadius: 3
                 },
                 {
                     label: 'Monto ' + this.textReceivedMasc + ' ($)',
                     data: dataValR,
                     borderColor: '#1ed760',
                     backgroundColor: 'rgba(30, 215, 96, 0.2)',
                     borderWidth: 2,
                     pointRadius: 3,
                     fill: true
                 }
             ]
          },
          options: {
              responsive: true,
              maintainAspectRatio: false,
              plugins: { 
                legend: { position: 'top', labels: { color: tc } },
                tooltip: {
                  callbacks: {
                    label: function(context) {
                      let label = context.dataset.label || '';
                      if (label) { label += ': '; }
                      if (context.parsed.y !== null) {
                        label += new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(context.parsed.y);
                      }
                      return label;
                    }
                  }
                }
              },
              scales: { 
                x: { ticks: { color: tc }, grid: { color: gc } },
                y: { 
                  beginAtZero: true,
                  grid: { color: gc },
                  ticks: {
                    color: tc,
                    callback: function(value) {
                      return '$' + (value / 1000 >= 1 || value / 1000 <= -1 ? (value / 1000) + 'k' : value);
                    }
                  }
                } 
              },
              interaction: { mode: 'index', intersect: false }
          }
       });
    }
  }
};
</script>

<style scoped>
/* HEADER FILTRO RECEIPT */
.pd-receipt-header {
  display: flex !important; justify-content: space-between !important; align-items: center !important; 
  margin-bottom: 24px !important; padding: 16px 20px !important; 
  background: #fff !important; border-radius: 16px !important; 
  border: 1px solid #F1F5F9 !important; box-shadow: 0 1px 3px rgba(0,0,0,.06) !important;
}
.pd-receipt-header h2 {
  font-size: 16px !important; color: #1E293B !important; font-weight: 700 !important; margin: 0 !important; display: flex !important; align-items: center !important; gap: 8px !important;
}
.pd-receipt-header p {
  font-size: 12px !important; color: #64748B !important; margin: 0 !important; margin-top: 4px !important;
}

/* REUSAMOS LOS ESTILOS DE DASHBOARDSUMMARY.VUE YA QUE TIENEN EL MISMO FORMATO */
.pds__kpis { display: grid !important; grid-template-columns: repeat(5,1fr) !important; gap: 12px !important; }
@media(max-width:1200px){ .pds__kpis{ grid-template-columns: repeat(3,1fr) !important; } }
@media(max-width:768px) { .pds__kpis{ grid-template-columns: repeat(2,1fr) !important; } }

.pds__kpi {
  background: #fff !important; border: 1px solid #F1F5F9 !important;
  border-radius: 16px !important; padding: 14px !important; box-shadow: 0 1px 3px rgba(0,0,0,.06) !important;
  display: flex !important; flex-direction: column !important; gap: 4px !important;
}
.pds__kpi-top { display: flex !important; align-items: center !important; justify-content: space-between !important; }
.pds__kpi-top i { font-size: 14px !important; }
.pds__kpi-label { font-size: 9px !important; font-weight: 700 !important; color: #94A3B8 !important; text-transform: uppercase !important; letter-spacing: .8px !important; }
.pds__kpi-value { font-size: 18px !important; font-weight: 800 !important; color: #1E293B !important; margin-top: 6px !important; }
.pds__kpi-sub   { font-size: 9px !important; color: #94A3B8 !important; font-weight: 500 !important; }

/* GRÁFICOS */
.pds__charts-row2 { display: grid !important; grid-template-columns: repeat(4,1fr) !important; gap: 16px !important; min-width: 0 !important; }
@media(max-width:1400px){ .pds__charts-row2{ grid-template-columns: repeat(2,1fr) !important; } }
@media(max-width:768px){ .pds__charts-row2{ grid-template-columns: 1fr !important; } }

.pds__chart-card {
  background: #fff !important; border: 1px solid #F1F5F9 !important;
  border-radius: 16px !important; padding: 18px !important; box-shadow: 0 1px 3px rgba(0,0,0,.06) !important;
  display: flex !important; flex-direction: column !important; gap: 10px !important; min-height: 280px !important;
  min-width: 0 !important; overflow: hidden !important;
}
.pds__card-head h3 { font-size: 10px !important; font-weight: 700 !important; color: #1E293B !important; text-transform: uppercase !important; letter-spacing: .6px !important; margin: 0 !important; }
.pds__card-head p  { font-size: 9px !important; color: #94A3B8 !important; margin-top: 2px !important; }
.pds__chart-wrap   { position: relative !important; flex: 1 !important; min-height: 160px !important; min-width: 0 !important; width: 100% !important; }

/* TABLA */
.pds__table-wrap { background: #fff !important; border: 1px solid #E2E8F0 !important; border-radius: 16px !important; overflow: hidden !important; box-shadow: 0 1px 3px rgba(0,0,0,.06) !important; }
.pds__legend-label { font-size: 12px !important; color: #1E293B !important; }
.pds__legend-sub { font-size: 11px !important; color: #64748B !important; }
.pds__table-head { display: flex !important; align-items: center !important; justify-content: space-between !important; padding: 14px 20px !important; background: #F8FAFC !important; border-bottom: 1px solid #E2E8F0 !important; }
.pds__table-head h3 { font-size: 10px !important; font-weight: 700 !important; color: #1E293B !important; text-transform: uppercase !important; letter-spacing: .6px !important; margin: 0 !important; }
.pds__table-head p  { font-size: 9px !important; color: #64748B !important; margin-top: 2px !important; }
.pds__table-scroll { overflow-x: auto !important; }
.pds__table { width: 100% !important; border-collapse: collapse !important; }
.pds__table thead tr { background: #F1F5F9 !important; }
.pds__table th { padding: 10px 14px !important; font-size: 9px !important; font-weight: 700 !important; color: #64748B !important; text-transform: uppercase !important; letter-spacing: .6px !important; white-space: nowrap !important; text-align: left !important; }
.pds__table td { padding: 10px 14px !important; font-size: 11px !important; color: #334155 !important; border-bottom: 1px solid #F1F5F9 !important; }
.pds__table tbody tr:hover { background: #FAFAFA !important; }
.text-center { text-align: center !important; }

.pds__estado { padding: 3px 8px !important; border-radius: 20px !important; font-size: 9px !important; font-weight: 700 !important; text-transform: uppercase !important; letter-spacing: .4px !important; white-space: nowrap !important; }
.pds__estado--closed   { background: #D1FAE5 !important; color: #065F46 !important; }
.pds__estado--open     { background: #FEF3C7 !important; color: #92400E !important; }
.pds__estado--canceled { background: #FEE2E2 !important; color: #991B1B !important; }

.pds__badge-oc { background: #F1F5F9 !important; border: 1px solid #E2E8F0 !important; border-radius: 6px !important; padding: 2px 6px !important; font-size: 10px !important; font-weight: 700 !important; font-family: monospace !important; white-space: nowrap !important; }
.pds__table-head span { font-size: 11px !important; color: #64748B !important; font-weight: 600 !important; white-space: nowrap !important; }

/* PAGINACIÓN */
.pds__pagination { display: flex !important; justify-content: space-between !important; align-items: center !important; padding: 12px 20px !important; border-top: 1px solid #E2E8F0 !important; background: #fff !important; }
.pds__pagination button { background: #F1F5F9 !important; border: 1px solid #E2E8F0 !important; border-radius: 6px !important; padding: 6px 12px !important; font-size: 11px !important; color: #334155 !important; font-weight: 600 !important; cursor: pointer !important; transition: all 0.2s !important; }
.pds__pagination button:hover:not(:disabled) { background: #E2E8F0 !important; }
.pds__pagination button:disabled { opacity: 0.5 !important; cursor: not-allowed !important; }
.pds__pagination span { font-size: 11px !important; color: #64748B !important; font-weight: 500 !important; }
.pd-table-search { position: relative !important; }
.pd-table-search i { position: absolute !important; left: 10px !important; top: 50% !important; transform: translateY(-50%) !important; color: #94A3B8 !important; font-size: 12px !important; }
.pd-table-search input { width: 250px !important; padding: 8px 12px 8px 30px !important; border: 1px solid #E2E8F0 !important; border-radius: 8px !important; font-size: 11px !important; color: #1E293B !important; outline: none !important; transition: border-color 0.2s !important; }
.pd-table-search input:focus { border-color: #058c99 !important; }
.pds__empty { text-align: center !important; padding: 32px !important; color: #94A3B8 !important; font-size: 12px !important; }
</style>
